import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <Trophy size={18} />
          <span>LoL Arena</span>
        </div>

        <nav className="site-footer__links">
          <Link to="/mentions-legales">Mentions légales</Link>
          <Link to="/politique-confidentialite">Confidentialité</Link>
          <Link to="/cgu">CGU</Link>
        </nav>

        <p className="site-footer__copy">
          © {year} LoL Arena — Non affilié à Riot Games
        </p>
      </div>
    </footer>
  );
}
